import styled from '@emotion/styled';
import { typography } from 'src/theme/typography';

const PaymentScheduleStyle = styled('div')`
    ${typography.bodyMd}
    color: var(--sand-700);
    .header {
        font-size: 20px;
        line-height: normal;
        letter-spacing: -0.03em;
        font-weight: 700;
        margin-bottom: 16px;
    }
    .box-values {
        display: flex;
        flex-direction: column;
        gap: 8px;
        .bold {
            font-weight: 600;
        }
        .text-right {
            text-align: right;
        }
    }
    .ant-form-item {
        margin-bottom: 12px;
        .ant-input {
            padding: 5px;
            border: 2px solid var(--orange-300);
            border-radius: 0;
            font-size: 14px;
            height: 32px;
            &.ant-input-status-error {
                border-color: #ff4d4f;
            }
        }
    }
    .btn-add {
        border-color: var(--orange-300);
        color: var(--orange-300);
    }
    @media screen and (max-width: 767px) {
        .box-step {
            display: flex;
            gap: 16px;
            .step-num {
                margin-bottom: 0px;
            }
        }
    }
`;
export default PaymentScheduleStyle;
